import * as React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import ListItem from '@mui/material/ListItem';

import ListItemText from '@mui/material/ListItemText';


import { NavLink } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';

import RoutersArr from '../routes';

import { ThemeProvider } from "@mui/material/styles";

import setThemeObj from '../hooks/useThemeMUI';

import MDBoxRoot from "./MDBox/MDBoxRoot";

import MDButtonRoot from "./MDButton/MDButtonRoot";
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "./MDsideNav/sidenavCollapse";

const getAdminStatus = gql(`
query GetAdminStatus {
  am_i_admin
}
`);

const getStaffStatus = gql(`
  query GetStaffStatus {
    am_i_staff
  }
  `);

export default function Dashboard({wthT, isSmallScreen }) {

  const { loading, error, data: admin_flag } = useQuery(getAdminStatus);
  const { data: staff_flag } = useQuery(getStaffStatus);

  
  const { pathname } = useLocation();
  const [menuActive, setMenuActive] = useState(null);
  const handleClick = (id) => {
    setMenuActive(id);
  };
//______
  useEffect(() => {
    const activeItem = RoutersArr.find(item => pathname.startsWith(item.link));
    setMenuActive(activeItem ? activeItem.name : null);
  }, [pathname]); 

  
  const filteredRoutes = RoutersArr.filter(item => {
    if (!item.leftMenuFlag) return false;
    if (item.adminFlag && !admin_flag?.am_i_admin) return false;
    if (item.staffFlag && !staff_flag?.am_i_staff) return false;
    return true;
  });
//____modern
  return (
    <ThemeProvider theme={setThemeObj}>
      <MDBoxRoot py={14} display={'flex'} 
                  justifyContent={'space-evenly'}
                  flexDirection={isSmallScreen ? 'column' :'row'}
      >
      {RoutersArr.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  {(() => {
                    var showLine = false;
                    if (!item.leftMenuFlag) return null;
                    if (item.adminFlag) {
                      if (admin_flag?.am_i_admin) showLine = true;
                    } else if (item.staffFlag) {
                      if (staff_flag?.am_i_staff) showLine = true;
                    } else showLine = true;

                    if (showLine) {
                      return (
                        <NavLink to={item.link} key={item.link} >
                          <ListItem key={item.name} component="li" 
                          sx={{paddingBottom:'16px',
                          flexDirection: isSmallScreen ? 'column' : 'row',
                          alignItems: 'stretch', 
                        color: 'dark', with:'100%'}}
                          >
                          <MDBoxRoot display={'flex'} 
                  justifyContent={'space-evenly'}
                  flexDirection={'column'}
                  alignItems= {'center'}
                  ownerState={{variant: "gradient",
                  color: "dark",
                  bgColor:'light',
                  borderRadius:'md'}}
                  sx={{minWidth:'150px'}}
                  >
                          {item.icon &&
    React.cloneElement(item.icon, {
      className: "MuiSvgIcon-root fontSizeLargest", sx: { fontSize: '36px' + " !important" }, 
    })}
                            <MDButtonRoot
                              ownerState={{
                                size: "large",
                                variant: "gradient",
                                color: "light",  
                                textTransform: "none",
                                isActive: menuActive === item.name,
                                iconOnly: isSmallScreen,
                              }}
                              sx={{
                                textTransform: 'none',
                                width: '100%',
                                marginRight:0,
                                fontSize: "1.25rem",
                                color:'light',
                                "& .MuiButton-startIcon": {
                                  marginRight: 0, 
                                  marginLeft: 0, 
                                },
                                "& .MuiListItemText-root span":{
                                  fontSize: "1.25rem",
                                  color: setThemeObj.palette.grey[900], 
                                }
                              }}
                              onClick={() => handleClick(item.name)}
                              //startIcon={item.icon}
                            >
                                <ListItemText
                                  primary={item.name}
                                  primaryTypographyProps={{
                                    fontSize: "1.5rem", 
                                    fontWeight: "bold", 
                                  }}
                                  sx={(setThemeObj) =>
                                    collapseText(setThemeObj, {
                                      whiteSidenav: false,
                                      miniSidenav: false,
                                      darkMode: false,
                                      active: menuActive === item.name,
                                    })}
                                />
                            </MDButtonRoot>
                            </MDBoxRoot>
                          </ListItem>
                        </NavLink>
                      )
                    }
                  })()}
                </React.Fragment>);
            })}
      </MDBoxRoot>
    </ThemeProvider>
  );
}
